import React from 'react'
import {useMultiStyleConfig, VStack} from '@chakra-ui/react'
import BenefitCard from './benefit-card'
import {delivery, returns, garanzia} from './benefit-labels'

const Benefits = () => {
    const styles = useMultiStyleConfig('Benefits')

    return (
        <VStack {...styles.benefitStack}>
            {[delivery, returns, garanzia].map((benefitLabel) => (
                <BenefitCard key={benefitLabel.id} benefitLabel={benefitLabel} />
            ))}
        </VStack>
    )
}

export default Benefits
